import React, { useState } from 'react'
import { useIntl } from 'gatsby-plugin-react-intl'
import { StaticImage } from 'gatsby-plugin-image'
import * as styles from './LanguagePicker.module.scss'

const LanguagePicker: React.FC = () => {
  const t = useIntl()
  const locale = t.locale.toUpperCase()
  const [menuVisible, setMenuVisible] = useState<boolean>(false)

  function handleMenuClick () {
    setMenuVisible(!menuVisible)
  }

  function handleLinkClick () {
    const selectedLanguage = locale === 'EN' ? 'fr' : 'en'
    document.cookie = `cglanguage=${selectedLanguage};path=/`
  }

  return (
    <div className={styles.cgLanguagePicker}>
      <button
        className={styles.cgLanguagePickerButton}
        onClick={() => handleMenuClick()}
      >
        <span className={styles.cgLanguagePickerButtonContent}>
          {locale === 'EN'
            ? <StaticImage
                src='./assets/flag_us_uk.png'
                alt='EN'
                className={styles.flag}
              />
            : <StaticImage
                src='./assets/flag_fr.png'
                alt='FR'
                className={styles.flag}
              />}
          <span className={styles.label}>{locale}</span>
        </span>
      </button>
      {menuVisible && (
        <div className={styles.cgLanguagePickerMenu}>
          <a
            className={styles.cgLanguagePickerButton}
            href={locale === 'EN' ? '/start/fr' : '/start'}
            onClick={handleLinkClick}
          >
            <span className={styles.cgLanguagePickerButtonContent}>
              {locale === 'EN'
                ? <StaticImage
                    src='./assets/flag_fr.png'
                    alt='FR'
                    className={styles.flag}
                  />
                : <StaticImage
                    src='./assets/flag_us_uk.png'
                    alt='EN'
                    className={styles.flag}
                  />}
              <span className={styles.label}>{locale === 'EN' ? 'FR' : 'EN'}</span>
            </span>
          </a>
        </div>
      )}
    </div>
  )
}

export default LanguagePicker
